import React from 'react';
import ReactDOM from 'react-dom';
import { LoadingSpinner } from "@app/form_components";
import { createUuid } from "@app/utilities";

export default class ElementGroup extends React.Component {
    
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    selectItem(itemId, item) {
        $(".element-item").removeClass("selected");
        this.getDomSelf().find("[data-item='" + itemId + "']").addClass("selected");
        this.props.context.setSelected(item, this.props.type);
    }

    componentDidMount() {
        this.getDomSelf().find(".collapse").collapse('show');
    }

    getElementItems(){
        var items = [];
        var type = this.props.type;
        const category= this.props.category;

        // sort items for display
        if (
            category === 'common'
            && (
                type === 'module'
                || type === 'object'
            )
        ) {
            this.props.items?.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
        }

        for (var i = 0; i < this.props.items.length; i++) {
            const item = this.props.items[i];

            let id = item.id;
            let iconClass = item.props ? item.props.iconClass : undefined;
            const name = item.name;
            let desc = item.props ? item.props.config.description : "";

            if (type === "module") {
                id = item.name;
                iconClass = "globe";
            }

            items.push(
                <div className={"col-md-3 element-item"} data-item={id} key={"item-" + createUuid()}
                    style={{ width: this.props.dynamicWidth + "%" }}
                    onClick={() => {
                        this.selectItem(id, item);
                    }}
                    onDoubleClick={() => {
                        this.selectItem(id, item);
                        this.props.context.handleAdd();
                    }}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td className="row-icon">
                                    <i className={"fe icon-" + iconClass} />
                                </td>
                            </tr>
                            <tr>
                                <td className="row-title">{name}</td>
                            </tr>
                            <tr><td className="row-text">{(() => {
                                if (desc && desc.length > 47) {
                                    desc = desc.substring(0, 47) + "…";
                                }
                                return desc;
                            })()}</td></tr>
                        </tbody>
                    </table>
                </div>
            );
        }
        if (items.length) {
            return items;
        }
        
    }

    getLoadingSpinner(){
        return (
            <div style={{minHeight: '105px', display:'flex', alignItems: 'center'}}>
                <LoadingSpinner />
            </div>
        )
    }

    renderRows(){
        const contentNotReady = this.props.isAsync && !this.props.asyncReady;
        const contentReady = this.props.isAsync && this.props.asyncReady || !this.props.isAsync;
        
        if(contentNotReady){
            return this.getLoadingSpinner();
        }
        if(contentReady){
            return this.getElementItems();
        }
    }

    render() {

        return (
            <div className="panel-group" role="tablist">
                
                <div className="panel panel-default">
                    {this.props.category !== "__default" && (
                        <div className="panel-heading" role="tab">
                            <div className="panel-title"
                                onClick={() => {
                                    this.getDomSelf().find(".collapse[data-tracker='" + this.props.category + "']").collapse('toggle');
                                }}
                            >
                                {this.props.category} (Read Only) 
                            </div>
                        </div>
                    )}
                    <div className="panel-collapse collapse in" role="tabpanel" data-tracker={this.props.category}>
                        <div className="panel-body">
                            <div className="row" style={{minHeight: '105px'}}>
                                {/* for common modules, display spinner until loaded */}
                                    {this.renderRows()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}